import { UserPlus, Search, CalendarCheck, Wallet, TrendingUp } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Heading } from "@/components/design-system/Heading";
import { motion } from "framer-motion";

const benefits = [
  {
    icon: UserPlus,
    title: "Crea tu perfil de portero",
    description: "Comienza tu viaje como portero"
  },
  {
    icon: Search,
    title: "Explora partidos disponibles",
    description: "Encuentra partidos que se ajusten a tu horario"
  },
  {
    icon: CalendarCheck,
    title: "Aplica a partidos",
    description: "Postúlate a los partidos que te interesen"
  },
  {
    icon: Wallet,
    title: "Gana dinero jugando",
    description: "Gana dinero haciendo lo que te apasiona"
  },
  {
    icon: TrendingUp,
    title: "Gana más mientras juegas",
    description: "Aumenta tus ingresos con más partidos"
  }
];

export const GoalkeeperBenefitsEs = () => {
  return (
    <div>
      <Heading level="h2" className="text-2xl font-bold mb-6 text-center">
        Para Porteros 🧤
      </Heading>
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {benefits.map((benefit, index) => (
          <motion.div
            key={benefit.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
            className="h-full"
          >
            <Card className="p-6 h-full bg-white/60 backdrop-blur border-2 border-primary/10 hover:border-primary/20 transition-all duration-300">
              <div className="mb-4 w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                <benefit.icon className="w-6 h-6 text-primary" />
              </div>
              <h3 className="text-xl font-semibold mb-2">{benefit.title}</h3>
              <p className="text-gray-600">{benefit.description}</p>
            </Card>
          </motion.div>
        ))}
      </div>
    </div>
  );
};